module.exports = __webpack_public_path__ + "img/ned.c43ee5a7.png";